var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{staticClass:"error-message",attrs:{"top":"","right":"","color":"error"},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},[_vm._v(" "+_vm._s(_vm.errorText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }